__turbopack_context__.v({
  "className": "arminfont_b5c8c61e-module__ki3uWG__className",
  "variable": "arminfont_b5c8c61e-module__ki3uWG__variable",
});
